module.exports = __webpack_public_path__ + "img/bg-image.2e191290.jpg";